import { useEffect } from 'react';
import {
  IChildrenCorpResponse,
  ISearchResults,
  useChildCorpsSearch,
} from 'src/utilities/useSearchHooks';

export type UseChildCorpSearchWithParamsReturn = {
  searchResults: ISearchResults<IChildrenCorpResponse>;
};

export const useChildCorpSearchWithParams = (
  corpId: string,
  pageSize: number
): UseChildCorpSearchWithParamsReturn => {
  const searchResults = useChildCorpsSearch(corpId, {
    size: pageSize,
  });

  useEffect(() => {
    searchResults.doSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { searchResults };
};
